import React, { useState} from 'react';
import {observer} from 'mobx-react';
import {GoogleLocationPicker} from 'shared/components';
import {Modal, ModalButtons} from 'shared/components/modals';

const LocationPickerModal = observer(({policy, onClose, onSave, modalOpen}) => {
  const {timeClockLocation} = policy;
  const [coords, setCoords] = useState(
    timeClockLocation ?
      {
        lat: parseFloat(timeClockLocation.latitude),
        lng: parseFloat(timeClockLocation.longitude)
      } : null
  );

  return (
    <Modal
      isOpen={modalOpen}
      onHide={onClose}
      size='md'
      title='time_tracking.manage.policies.edit.policy_details.Set Working Location'
    >
      <GoogleLocationPicker
        value={coords}
        onChange={setCoords}
      />
      <ModalButtons
        onSave={() => onSave(coords)}
        onCancel={onClose}
      />
    </Modal>
  );
});

export default LocationPickerModal;
